<template>
  <div class="grid-x text-right grid-y2">
    <span class="register">
      Register
    </span>
      <Panel 
      title="Register" 
      content="Please Enter Details Below"
      width="40"
      height="30"
      posX="-500"
      passedComponent="RegistrationForm"
    />
  </div>
</template>

<script>

export default {
  name: 'Register',
  props: {
    msg: String
  }
}
</script>

<style scoped>

</style>
